import { render, staticRenderFns } from "./ShowCredentialTerminalesPuntosColombia.vue?vue&type=template&id=2ece367b"
import script from "./ShowCredentialTerminalesPuntosColombia.vue?vue&type=script&lang=js"
export * from "./ShowCredentialTerminalesPuntosColombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ece367b')) {
      api.createRecord('2ece367b', component.options)
    } else {
      api.reload('2ece367b', component.options)
    }
    module.hot.accept("./ShowCredentialTerminalesPuntosColombia.vue?vue&type=template&id=2ece367b", function () {
      api.rerender('2ece367b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/LoyaltyConfig/components/ShowCredentialTerminalesPuntosColombia.vue"
export default component.exports